import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectTeacherPayoutEligibilityRetrieval = createSelector(
  [(state: AppState) => state.teacher.payoutEligibilityRetrieval],
  ({ data, fetching }) => ({ data, fetching }),
);
